import ShopResultsDescription from "./ShopResultsDescription";

export default ShopResultsDescription;
